import React, {useState, useEffect} from 'react';
import Clessidra from '../Pagine/Clessidra'
import stile from './stile.module.css';
import FadeLoader from "react-spinners/FadeLoader"; // per i video, non uso Clessidra.js perché va posizionato diversamente, nel riquadro e non a centro schermo

function AllenamentiVisualizzaScheda(props) {
    const PAGINE = {
        "caricamentoDati": 1,
        "visualizzaScheda": 2,
    };
    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [numEsercizio, setNumEsercizio] = useState(-1);
    const [elencoEserciziScheda, setElencoEserciziScheda] = useState([]); // array di oggetti json
    const [modoVisualizzazione, setModoVisualizzazione] = useState(0); // intero, 0 o 1: 0=scheda intera, 1=immagine o video a tutto schermo
    const [videoUrl, setVideoUrl] = useState('');

    function scaricaImmagineEsercizio(numEsercizio) {
        //console.log("scaricaImmagineEsercizio(numEsercizio="+numEsercizio+") --> nome="+elencoEserciziScheda[numEsercizio].nome+" id="+elencoEserciziScheda[numEsercizio].id);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                op: "esercizioRecuperaDati", 
                id: elencoEserciziScheda[numEsercizio].id,
                scaricaVideo: 1,
                emak: props.emak, 
                sessionId:props.sessionId
            })
        };
        
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.verifvers === 0) {
                        // necessario aggiornare la app
                        props.callbackAggiornaApp();
                        return;
                    }
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { 
                        window.alert("Operazione fallita: sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                        props.callback(props.PAGINECLIENTI.login);
                        return; 
                    }
                    var e = [...elencoEserciziScheda];                    
                    e[numEsercizio].tipoImmagine = valore_di_ritorno.risultatoRitorno[0].TYPE;
                    if (valore_di_ritorno.risultatoRitorno[0].TYPE.startsWith("video")) {     
                        e[numEsercizio].immagineBase64 = "video";
                        console.log("setVideoUrl");
                        setVideoUrl(valore_di_ritorno.risultatoRitorno[0].FILE);  
                    } else {
                        e[numEsercizio].immagineBase64 = valore_di_ritorno.risultatoRitorno[0].FILE;
                    }
                    setElencoEserciziScheda(e);
                },
                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );
    }

    function scaricaEserciziScheda(id, paginaSeguente) {
        setPagina(PAGINE.caricamentoDati);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                op: "elencoEserciziScheda", 
                id: id,
                emak: props.emak, 
                sessionId:props.sessionId
            })
        };
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.verifvers === 0) {
                        // necessario aggiornare la app
                        props.callbackAggiornaApp();
                        return;
                    }
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { 
                        window.alert("Operazione fallita: sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                        props.callback(props.PAGINECLIENTI.login);
                        return; 
                    }
                    if (valore_di_ritorno.risultatoRitorno[0] == undefined) {
                        // scheda vuota
                        setElencoEserciziScheda([]);
                    } else{
                        var el=[], esercizio;
                        for (var i=0; i<valore_di_ritorno.risultatoRitorno.length; i++) {
                            esercizio = {
                                id:valore_di_ritorno.risultatoRitorno[i].ID_ESERCIZIO,
                                nome:valore_di_ritorno.risultatoRitorno[i].ESERCIZIO,
                                descrizione: valore_di_ritorno.risultatoRitorno[i].SPIEGAZIONE,
                                classe:valore_di_ritorno.risultatoRitorno[i].CLASSE,
                                ripetizioni:valore_di_ritorno.risultatoRitorno[i].RIPETIZIONI,
                                serie:valore_di_ritorno.risultatoRitorno[i].SERIE,
                                recupero:valore_di_ritorno.risultatoRitorno[i].RECUPERO_TRA_SERIE,
                                note:valore_di_ritorno.risultatoRitorno[i].NOTE_ESERCIZIO,
                                immagineBase64: "?",
                                tipoImmagine: "?"
                            };
                            el.push(esercizio);
                        }
                    }
                    setElencoEserciziScheda(el);
                    setNumEsercizio(0);
                    setPagina(paginaSeguente);                    
                },
                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );
    }

    useEffect(() => {
        scaricaEserciziScheda(props.idScheda, PAGINE.visualizzaScheda);
    }, [])

    useEffect(() => {
        if (elencoEserciziScheda[numEsercizio]!==undefined) {
            if (elencoEserciziScheda[numEsercizio].immagineBase64==="?") { 
                scaricaImmagineEsercizio(numEsercizio);
            }
            if (elencoEserciziScheda[numEsercizio].immagineBase64==="video") {
                setVideoUrl("");
                scaricaImmagineEsercizio(numEsercizio);
            }
        }
    }, [numEsercizio])

    if (pagina === PAGINE.caricamentoDati) {
        return (<div style={{ textAlign: 'center' }}><Clessidra loading={true} /></div>);
    }
    
    if (pagina === PAGINE.visualizzaScheda && elencoEserciziScheda === undefined) {
        return (<div style={{ textAlign: 'center' }}><Clessidra loading={true} /></div>);
    }
    
    if (pagina === PAGINE.visualizzaScheda && elencoEserciziScheda.length === 0) {
        return (
            <p style={{ paddingBottom: 5, paddingTop: 5 }} class={stile.eventiModificaTestoTitoli}>
                Errore: la scheda {props.nomeScheda} non ha esercizi
            </p>
        );
    }
    
    if (
        pagina === PAGINE.visualizzaScheda &&
        elencoEserciziScheda.length > 0 &&
        modoVisualizzazione === 0
    ) {
        const esercizio = elencoEserciziScheda[numEsercizio];

        return (
            <div className={stile.schedaAllenamentoPagina}>

                <div className={stile.schedaAllenamentoContenuto}>

                    {/* Nome scheda */}
                    <div className={stile.schedaAllenamentoNomeScheda}>
                        <div className={stile.schedaAllenamentoTitoloScheda}>
                            {props.nomeScheda}
                        </div>

                        {props.nomePersonaSelezionata !== undefined &&
                        props.nomePersonaSelezionata !== "" &&
                            <div className={stile.schedaAllenamentoPersona}>
                                {props.nomePersonaSelezionata}
                            </div>
                        }
                    </div>


                    {/* Avanzamento */}
                    <div className={stile.schedaAllenamentoAvanzamento}>
                        <div className={stile.schedaAllenamentoAvanzamentoTesto}>
                            <span>
                                Esercizio <strong>{numEsercizio + 1}</strong> di{" "}
                                <strong>{elencoEserciziScheda.length}</strong>
                            </span>

                            <span>
                                {Math.round(
                                    (numEsercizio + 1) * 100 /
                                    elencoEserciziScheda.length
                                )}%
                            </span>
                        </div>

                        <div className={stile.schedaAllenamentoBarra}>
                            <div
                                className={stile.schedaAllenamentoBarraRiempimento}
                                style={{
                                    width:
                                        (numEsercizio + 1) * 100 /
                                        elencoEserciziScheda.length + "%"
                                }}
                            />
                        </div>
                    </div>


                    {/* Card esercizio */}
                    <div className={stile.schedaAllenamentoCard}>

                        <div className={stile.schedaAllenamentoNomeEsercizio}>
                            {esercizio.nome}
                        </div>

                        {esercizio.classe !== "" &&
                            <div className={stile.schedaAllenamentoClasse}>
                                {esercizio.classe}
                            </div>
                        }

                        {esercizio.descrizione !== "" &&
                            <div className={stile.schedaAllenamentoDescrizione}>
                                {esercizio.descrizione}
                            </div>
                        }


                        {/* Immagine/video */}
                        <div className={stile.schedaAllenamentoMedia}>

                            {esercizio.immagineBase64 === "" ?
                                <div></div>
                            :
                                esercizio.immagineBase64 === "?" ?
                                    <FadeLoader
                                        color={"#000000"}
                                        loading={true}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                            :
                                esercizio.tipoImmagine.startsWith("video") ?
                                    videoUrl === "" ?
                                        <FadeLoader
                                            color={"#000000"}
                                            loading={true}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                        />
                                    :
                                        <video
                                            className={stile.schedaAllenamentoMediaContenuto}
                                            key={videoUrl}
                                            controls
                                        >
                                            <source
                                                src={videoUrl}
                                                type={esercizio.tipoImmagine}
                                            />
                                        </video>
                                :
                                    <img
                                        className={stile.schedaAllenamentoMediaContenuto}
                                        src={esercizio.immagineBase64}
                                        alt={esercizio.nome}
                                    />
                            }

                            {esercizio.immagineBase64 !== "" &&
                            esercizio.immagineBase64 !== "?" &&
                                <div
                                    className={stile.schedaAllenamentoZoomSovrapposto}
                                    onClick={() => setModoVisualizzazione(1)}
                                >
                                    <img
                                        className={stile.iconaPiccolaQuadrata}
                                        src={require('./zoompiu.png')}
                                        alt="Ingrandisci"
                                    />
                                </div>
                            }

                        </div>


                        {/* Dati esercizio */}
                        <div className={stile.schedaAllenamentoParametri}>

                            <div className={stile.schedaAllenamentoParametro}>
                                <div className={stile.schedaAllenamentoParametroValore}>
                                    {esercizio.serie !== "" ? esercizio.serie : "–"}
                                </div>
                                <div className={stile.schedaAllenamentoParametroNome}>
                                    Serie
                                </div>
                            </div>

                            <div className={stile.schedaAllenamentoParametro}>
                                <div className={stile.schedaAllenamentoParametroValore}>
                                    {esercizio.ripetizioni !== "" ?
                                        esercizio.ripetizioni : "–"}
                                </div>
                                <div className={stile.schedaAllenamentoParametroNome}>
                                    Ripetizioni
                                </div>
                            </div>

                            <div className={stile.schedaAllenamentoParametro}>
                                <div className={stile.schedaAllenamentoParametroValore}>
                                    {esercizio.recupero !== "" ?
                                        esercizio.recupero : "–"}
                                </div>
                                <div className={stile.schedaAllenamentoParametroNome}>
                                    Recupero
                                </div>
                            </div>

                        </div>                        

                    </div>


                    {/* Note esercizio */}
                    {esercizio.note !== "" &&
                        <div className={stile.schedaAllenamentoNote}>
                            <div className={stile.schedaAllenamentoNoteTitolo}>
                                Note esercizio
                            </div>
                            <div className={stile.schedaAllenamentoNoteTesto}>
                                {esercizio.note}
                            </div>
                        </div>
                    }


                    {/* Note scheda */}
                    {props.noteScheda !== undefined &&
                    props.noteScheda !== "" &&
                        <div className={stile.schedaAllenamentoNote}>
                            <div className={stile.schedaAllenamentoNoteTitolo}>
                                Note scheda
                            </div>
                            <div className={stile.schedaAllenamentoNoteTesto}>
                                {props.noteScheda}
                            </div>
                        </div>
                    }

                </div>


                {/* Navigazione fissa in basso */}
                <div className={stile.schedaAllenamentoNavigazione}>

                    <div
                        className={[
                            numEsercizio > 0
                                ? stile.baVerdeSoft
                                : stile.baDisabilitato,
                            stile.baNormale,
                            stile.baFlex
                        ].join(" ")}
                        onClick={() => {
                            if (numEsercizio > 0)
                                setNumEsercizio(numEsercizio - 1);
                        }}
                    >
                        <img
                            className={stile.iconaPiccolaQuadrata}
                            src={require('./frecciasinistra-bianca.png')}
                            alt=""
                        />                        
                    </div>

                    <div
                        className={[
                            numEsercizio < elencoEserciziScheda.length - 1
                                ? stile.baVerdeSoft
                                : stile.baDisabilitato,
                            stile.baNormale,
                            stile.baFlex,
                            stile.baSecondoBottone
                        ].join(" ")}
                        onClick={() => {
                            if (numEsercizio < elencoEserciziScheda.length - 1)
                                setNumEsercizio(numEsercizio + 1);
                        }}
                    >                        
                        <img
                            className={stile.iconaPiccolaQuadrata}
                            src={require('./frecciadestra-bianca.png')}
                            alt=""
                        />
                    </div>

                </div>

            </div>
        );
    }

    if (
        pagina === PAGINE.visualizzaScheda &&
        elencoEserciziScheda.length > 0 &&
        modoVisualizzazione === 1
    ) {
        const esercizio = elencoEserciziScheda[numEsercizio];

        return (
            <div className={stile.schedaAllenamentoPaginaFull}>

                {/* Intestazione */}
                <div className={stile.schedaAllenamentoFullIntestazione}>

                    <div className={stile.schedaAllenamentoAvanzamento}>
                        <div className={stile.schedaAllenamentoAvanzamentoTesto}>
                            <span>
                                Esercizio <strong>{numEsercizio + 1}</strong> di{" "}
                                <strong>{elencoEserciziScheda.length}</strong>
                            </span>

                            <span>
                                {Math.round(
                                    (numEsercizio + 1) * 100 /
                                    elencoEserciziScheda.length
                                )}%
                            </span>
                        </div>

                        <div className={stile.schedaAllenamentoBarra}>
                            <div
                                className={stile.schedaAllenamentoBarraRiempimento}
                                style={{
                                    width:
                                        (numEsercizio + 1) * 100 /
                                        elencoEserciziScheda.length + "%"
                                }}
                            />
                        </div>
                    </div>

                    <div className={stile.schedaAllenamentoFullNomeEsercizio}>
                        {esercizio.nome}
                    </div>

                    <div className={stile.schedaAllenamentoFullParametri}>
                        {esercizio.serie !== "" &&
                            <span>
                                <strong>{esercizio.serie}</strong> serie
                            </span>
                        }

                        {esercizio.ripetizioni !== "" &&
                        esercizio.ripetizioni != 0 &&
                            <span>
                                <strong>{esercizio.ripetizioni}</strong> rip.
                            </span>
                        }

                        {esercizio.recupero !== "" &&
                            <span>
                                recupero <strong>{esercizio.recupero}</strong>
                            </span>
                        }
                    </div>

                </div>


                {/* Immagine / video ingrandito */}
                <div className={stile.schedaAllenamentoMediaFull}>

                    {esercizio.immagineBase64 === "?" ?

                        <FadeLoader
                            color={"#000000"}
                            loading={true}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />

                    :

                        esercizio.tipoImmagine.startsWith("video") ?

                            videoUrl === "" ?

                                <FadeLoader
                                    color={"#000000"}
                                    loading={true}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />

                            :

                                <video
                                    className={stile.schedaAllenamentoMediaFullContenuto}
                                    key={videoUrl}
                                    controls
                                >
                                    <source
                                        src={videoUrl}
                                        type={esercizio.tipoImmagine}
                                    />
                                    Your browser does not support the video tag.
                                </video>

                        :

                            <img
                                className={stile.schedaAllenamentoMediaFullContenuto}
                                src={esercizio.immagineBase64}
                                alt={esercizio.nome}
                            />
                    }


                    {/* Lente per tornare alla visualizzazione normale */}
                    {esercizio.immagineBase64 !== "" &&
                    esercizio.immagineBase64 !== "?" &&
                        <div
                            className={stile.schedaAllenamentoZoomSovrappostoFull}
                            onClick={() => setModoVisualizzazione(0)}
                        >
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require('./zoommeno.png')}
                                alt="Riduci"
                            />
                        </div>
                    }

                </div>


                {/* Navigazione fissa in basso */}
                <div className={stile.schedaAllenamentoNavigazione}>

                    <div
                        className={[
                            numEsercizio > 0
                                ? stile.baVerdeSoft
                                : stile.baDisabilitato,
                            stile.baNormale,
                            stile.baFlex
                        ].join(" ")}
                        onClick={() => {
                            if (numEsercizio > 0)
                                setNumEsercizio(numEsercizio - 1);
                        }}
                    >
                        <img
                            className={stile.iconaPiccolaQuadrata}
                            src={require('./frecciasinistra-bianca.png')}
                            alt=""
                        />
                    </div>

                    <div
                        className={[
                            numEsercizio < elencoEserciziScheda.length - 1
                                ? stile.baVerdeSoft
                                : stile.baDisabilitato,
                            stile.baNormale,
                            stile.baFlex,
                            stile.baSecondoBottone
                        ].join(" ")}
                        onClick={() => {
                            if (numEsercizio < elencoEserciziScheda.length - 1)
                                setNumEsercizio(numEsercizio + 1);
                        }}
                    >
                        <img
                            className={stile.iconaPiccolaQuadrata}
                            src={require('./frecciadestra-bianca.png')}
                            alt=""
                        />
                    </div>

                </div>

            </div>
        );
    }

    return (
        <div>Errore pagina non trovata (AllenamentiVisualizzaScheda)</div>
    )
}

export default AllenamentiVisualizzaScheda;
